module.exports = {
  externalObjectLoader: function(url, onloadScript, id) {
    var doc, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = 'javascript:false';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.css = 'width: 0;height: 0;border: 0';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      iframe.src = "javascript:var d=document.open();d.domain='" + document.domain + "';void 0";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (typeof dom !== "undefined" && dom !== null) {
        this.domain = dom;
      }
      scriptInit = this.createElement('script');
      scriptInit.type = 'text/javascript';
      scriptInit.innerHTML = 'Groupon=window.parent.Groupon;$=window.parent.$';
      this.body.appendChild(scriptInit);
      js = this.createElement('script');
      js.type = 'text/javascript';
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  },
  externalObjectLoaderOnready: function(fn) {
    if (typeof fn === 'function') {
      return $(document).ready(fn);
    }
  }
};

